(() => {
const root = document.getElementById("FindShiftCalendar-CommandCenter");
if (!root || root.dataset.fscInitialized === "true") return;
root.dataset.fscInitialized = "true";
const refs = {
sync: root.querySelector("[data-fsc-sync]"),
syncText: root.querySelector("[data-fsc-sync-text]"),
notice: root.querySelector("[data-fsc-notice]"),
login: root.querySelector("[data-fsc-login]"),
loginLink: root.querySelector("[data-fsc-login-link]"),
content: root.querySelector("[data-fsc-content]"),
recommendation: root.querySelector("[data-fsc-recommendation]"),
recommendationBadge: root.querySelector("[data-fsc-recommendation-badge]"),
recommendationTitle: root.querySelector("[data-fsc-recommendation-title]"),
recommendationMeta: root.querySelector("[data-fsc-recommendation-meta]"),
recommendationCountdown: root.querySelector("[data-fsc-recommendation-countdown]"),
recommendationModule: root.querySelector("[data-fsc-recommendation-module]"),
recommendationCopy: root.querySelector("[data-fsc-recommendation-copy]"),
recommendationChecklist: root.querySelector("[data-fsc-recommendation-checklist]"),
recommendationPrimary: root.querySelector("[data-fsc-recommendation-primary]"),
recommendationSecondary: root.querySelector("[data-fsc-recommendation-secondary]"),
recommendationAction: root.querySelector(".fsc__recommendation-action"),
whatsapp: root.querySelector("[data-fsc-whatsapp]"),
whatsappForm: root.querySelector("[data-fsc-whatsapp-form]"),
whatsappToggle: root.querySelector("[data-fsc-whatsapp-toggle]"),
whatsappSummary: root.querySelector("[data-fsc-whatsapp-summary]"),
whatsappPhone: root.querySelector("[data-fsc-whatsapp-phone]"),
whatsappAccepted: root.querySelector("[data-fsc-whatsapp-accepted]"),
whatsappError: root.querySelector("[data-fsc-whatsapp-error]"),
whatsappEnable: root.querySelector("[data-fsc-whatsapp-enable]"),
whatsappStatus: root.querySelector("[data-fsc-whatsapp-status]"),
whatsappState: root.querySelector("[data-fsc-whatsapp-state]"),
whatsappPhoneDisplay: root.querySelector("[data-fsc-whatsapp-phone-display]"),
whatsappDisable: root.querySelector("[data-fsc-whatsapp-disable]"),
connectPanel: root.querySelector("[data-fsc-connect-panel]"),
connectToggle: root.querySelector("[data-fsc-connect-toggle]"),
connectContent: root.querySelector("[data-fsc-connect-content]"),
connectStatus: root.querySelector("[data-fsc-connect-status]"),
connectCalendarStatusPill: root.querySelector("[data-fsc-calendar-status-pill]"),
connectWhatsappStatusPill: root.querySelector("[data-fsc-whatsapp-status-pill]"),
calendarFeed: root.querySelector("[data-fsc-calendar-feed]"),
feedApple: root.querySelector("[data-fsc-feed-apple]"),
feedGoogle: root.querySelector("[data-fsc-feed-google]"),
feedCopy: root.querySelector("[data-fsc-feed-copy]"),
feedRegenerate: root.querySelector("[data-fsc-feed-regenerate]"),
feedUrl: root.querySelector("[data-fsc-feed-url]"),
refresh: root.querySelector("[data-fsc-refresh]"),
previousMonth: root.querySelector("[data-fsc-previous-month]"),
nextMonth: root.querySelector("[data-fsc-next-month]"),
monthLabel: root.querySelector("[data-fsc-month-label]"),
calendarGrid: root.querySelector("[data-fsc-calendar-grid]"),
shiftList: root.querySelector("[data-fsc-shift-list]"),
shiftListHint: root.querySelector("[data-fsc-shift-list-hint]"),
statNext: root.querySelector("[data-fsc-stat-next]"),
statRegularNight: root.querySelector("[data-fsc-stat-regular-night]"),
statLong24: root.querySelector("[data-fsc-stat-long-24h]"),
statPlanned: root.querySelector("[data-fsc-stat-planned]"),
planAnalysis: root.querySelector("[data-fsc-plan-analysis]"),
planAnalysisTitle: root.querySelector("[data-fsc-plan-analysis-title]"),
planAnalysisCopy: root.querySelector("[data-fsc-plan-analysis-copy]"),
planAnalysisAction: root.querySelector("[data-fsc-plan-analysis-action]"),
modal: root.querySelector("[data-fsc-modal]"),
closeModal: root.querySelectorAll("[data-fsc-close-modal]"),
dialogTitle: root.querySelector("[data-fsc-dialog-title]"),
form: root.querySelector("[data-fsc-form]"),
formError: root.querySelector("[data-fsc-form-error]"),
shiftId: root.querySelector("[data-fsc-shift-id]"),
shiftType: root.querySelector("[data-fsc-shift-type]"),
title: root.querySelector("[data-fsc-title]"),
start: root.querySelector("[data-fsc-start]"),
end: root.querySelector("[data-fsc-end]"),
note: root.querySelector("[data-fsc-note]"),
save: root.querySelector("[data-fsc-save]"),
delete: root.querySelector("[data-fsc-delete]"),
};
const access = {
firstShift: root.dataset.hasFirstShift === "true",
duty: root.dataset.hasDuty === "true",
nightwatch: root.dataset.hasNightwatch === "true",
recovery: root.dataset.hasRecovery === "true",
whatsappOptin: root.dataset.whatsappOptinEnabled === "true",
};
const state = {
customer: null,
shifts: [],
shiftTypeOptions: [],
csrfToken: "",
timeZone: "Europe/Berlin",
monthCursor: null,
busy: false,
whatsappBusy: false,
whatsappProfile: null,
calendarFeed: null,
calendarFeedBusy: false,
recommendationTimer: null,
noticeTimer: null,
};
const monthFormatter = new Intl.DateTimeFormat("de-DE", {
month: "long",
year: "numeric",
});
function setSync(status, label) {
refs.sync.dataset.state = status;
refs.syncText.textContent = label;
}
function showNotice(message, kind = "info") {
if (!refs.notice) return;
if (state.noticeTimer) {
clearTimeout(state.noticeTimer);
state.noticeTimer = null;
}
refs.notice.textContent = message;
refs.notice.dataset.kind = kind;
refs.notice.hidden = false;
if (kind === "success") {
state.noticeTimer = window.setTimeout(function () {
hideNotice();
}, 3000);
}
}
function hideNotice() {
if (!refs.notice) return;
if (state.noticeTimer) {
clearTimeout(state.noticeTimer);
state.noticeTimer = null;
}
refs.notice.hidden = true;
refs.notice.textContent = "";
refs.notice.removeAttribute("data-kind");
}
function setFormError(message = "") {
refs.formError.textContent = message;
refs.formError.hidden = !message;
}
async function api(action, options = {}) {
const response = await fetch(
`/apps/find-system?action=${encodeURIComponent(action)}`,
{
method: options.method || "GET",
credentials: "same-origin",
cache: "no-store",
headers: {
Accept: "application/json",
...(options.body
? { "Content-Type": "application/json" }
: {}),
},
...(options.body
? { body: JSON.stringify(options.body) }
: {}),
},
);
const raw = await response.text();
let payload;
try {
payload = JSON.parse(raw);
} catch {
throw new Error("Die Antwort des Servers konnte nicht verarbeitet werden.");
}
if (!response.ok || payload.ok !== true) {
throw new Error(payload.error || `Serverfehler ${response.status}`);
}
return payload;
}
function getZonedParts(date, timeZone = state.timeZone) {
const parts = new Intl.DateTimeFormat("en-CA", {
timeZone,
year: "numeric",
month: "2-digit",
day: "2-digit",
hour: "2-digit",
minute: "2-digit",
second: "2-digit",
hourCycle: "h23",
}).formatToParts(date);
return Object.fromEntries(
parts
.filter((part) => part.type !== "literal")
.map((part) => [part.type, part.value]),
);
}
function getDateKey(date, timeZone = state.timeZone) {
const parts = getZonedParts(date, timeZone);
return `${parts.year}-${parts.month}-${parts.day}`;
}
function getDateTimeLocalValue(isoString) {
const parts = getZonedParts(new Date(isoString));
return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}
function getTimeZoneOffsetMilliseconds(date, timeZone) {
const parts = getZonedParts(date, timeZone);
const representedAsUtc = Date.UTC(
Number(parts.year),
Number(parts.month) - 1,
Number(parts.day),
Number(parts.hour),
Number(parts.minute),
Number(parts.second),
);
return representedAsUtc - date.getTime();
}
function zonedLocalValueToIso(localValue, timeZone = state.timeZone) {
const match = localValue.match(
/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/,
);
if (!match) {
throw new Error("Bitte gib Beginn und Ende vollständig an.");
}
const [, year, month, day, hour, minute] = match;
const utcGuess = Date.UTC(
Number(year),
Number(month) - 1,
Number(day),
Number(hour),
Number(minute),
0,
);
let date = new Date(utcGuess);
let offset = getTimeZoneOffsetMilliseconds(date, timeZone);
date = new Date(utcGuess - offset);
const refinedOffset = getTimeZoneOffsetMilliseconds(date, timeZone);
if (refinedOffset !== offset) {
date = new Date(utcGuess - refinedOffset);
}
return date.toISOString();
}
function dateKeyToUtcDate(dateKey) {
const [year, month, day] = dateKey.split("-").map(Number);
return new Date(Date.UTC(year, month - 1, day));
}
function utcDateToDateKey(date) {
return [
date.getUTCFullYear(),
String(date.getUTCMonth() + 1).padStart(2, "0"),
String(date.getUTCDate()).padStart(2, "0"),
].join("-");
}
function getShiftDateKeys(shift) {
const startKey = getDateKey(new Date(shift.start_at));
const endKey = getDateKey(new Date(shift.end_at));
const startDate = dateKeyToUtcDate(startKey);
const endDate = dateKeyToUtcDate(endKey);
const keys = [];
for (
let cursor = startDate.getTime(), index = 0;
cursor <= endDate.getTime() && index < 40;
cursor += 86400000, index += 1
) {
keys.push(utcDateToDateKey(new Date(cursor)));
}
return keys;
}
function getTypeLabel(type) {
return (
state.shiftTypeOptions.find((option) => option.value === type)?.label ||
type
);
}
function formatDateTime(isoString) {
return new Intl.DateTimeFormat("de-DE", {
timeZone: state.timeZone,
weekday: "short",
day: "2-digit",
month: "2-digit",
year: "numeric",
hour: "2-digit",
minute: "2-digit",
}).format(new Date(isoString));
}
function formatShortDateTime(isoString) {
return new Intl.DateTimeFormat("de-DE", {
timeZone: state.timeZone,
day: "2-digit",
month: "2-digit",
hour: "2-digit",
minute: "2-digit",
}).format(new Date(isoString));
}
function formatDuration(shift) {
const durationHours =
(new Date(shift.end_at).getTime() - new Date(shift.start_at).getTime()) /
3600000;
return `${Number.isInteger(durationHours) ? durationHours : durationHours.toFixed(1)} h`;
}
function initializeMonthCursor() {
if (state.monthCursor) return;
const parts = getZonedParts(new Date());
state.monthCursor = {
year: Number(parts.year),
month: Number(parts.month),
};
}
function shiftMonth(delta) {
initializeMonthCursor();
const cursor = new Date(
Date.UTC(state.monthCursor.year, state.monthCursor.month - 1 + delta, 1),
);
state.monthCursor = {
year: cursor.getUTCFullYear(),
month: cursor.getUTCMonth() + 1,
};
renderCalendar();
}
function getUpcomingShifts() {
const now = Date.now();
return state.shifts
.filter((shift) => new Date(shift.end_at).getTime() >= now)
.sort(
(a, b) =>
new Date(a.start_at).getTime() - new Date(b.start_at).getTime(),
);
}
function formatCountdown(shift) {
const now = Date.now();
const start = new Date(shift.start_at).getTime();
const end = new Date(shift.end_at).getTime();
const target = start > now ? start : end;
const distance = Math.max(0, target - now);
const totalMinutes = Math.max(1, Math.ceil(distance / 60000));
const days = Math.floor(totalMinutes / 1440);
const hours = Math.floor((totalMinutes % 1440) / 60);
const minutes = totalMinutes % 60;
const parts = [];
if (days) parts.push(`${days} TAG${days === 1 ? "" : "E"}`);
if (hours) parts.push(`${hours} STD.`);
if (!days && minutes) parts.push(`${minutes} MIN.`);
return start > now
? `STARTET IN ${parts.join(" ")}`
: `DIENST LÄUFT · NOCH ${parts.join(" ")}`;
}
function getRecommendation(shift) {
const type = shift.shift_type;
const onlyRecovery = access.recovery && !access.firstShift && !access.duty && !access.nightwatch;
if (type === "long_24h" || type === "standby") {
if (access.nightwatch) {
return {
badge: type === "long_24h" ? "NIGHTWATCH // 24 STD. DIENST" : "NIGHTWATCH // BEREITSCHAFT",
module: "FiND NIGHTWATCH",
copy: "Öffne deinen NightWatch-Kompass und prüfe deine Versorgung für die lange Belastungsphase.",
items: [
"Versorgung für die gesamte Dienstlänge prüfen",
"Trinkmenge und Ruhefenster bewusst einplanen",
access.recovery ? "Recovery nach dem Dienst vorbereiten" : "Recovery als nächsten Systembaustein vormerken",
],
primaryLabel: "NIGHTWATCH-KOMPASS STARTEN →",
primaryHref: "/pages/nightwatch-kompass",
secondaryLabel: access.recovery ? "REFILL PRÜFEN →" : "RECOVERY FÜR DANACH →",
secondaryHref: access.recovery ? "/products/nightwatch-refill" : "/products/find-recovery",
};
}
return {
badge: type === "long_24h" ? "NIGHTWATCH // 24 STD. DIENST" : "NIGHTWATCH // BEREITSCHAFT",
module: "FiND NIGHTWATCH",
copy: "Für diesen langen Dienst ist NightWatch der passende Baustein. Schalte ihn gezielt frei.",
items: [
"Versorgung für die gesamte Dienstlänge prüfen",
"Trinkmenge und Ruhefenster bewusst einplanen",
"Recovery nach dem Dienst vorbereiten",
],
primaryLabel: "NIGHTWATCH FREISCHALTEN →",
primaryHref: "/products/find-nightwatch",
secondaryLabel: "",
secondaryHref: "",
};
}
if (type === "recovery") {
return {
badge: "RECOVERY // REGENERATION",
module: "FiND RECOVERY",
copy: access.recovery
? "Öffne deinen Recovery-Kompass und gestalte den Übergang aus dem Dienst bewusst."
: "Für diese Regenerationsphase ist Recovery der passende Baustein.",
items: [
"Dienst gedanklich abschließen",
"Reizniveau bewusst reduzieren",
"Erholung strukturiert einleiten",
],
primaryLabel: access.recovery ? "RECOVERY-KOMPASS STARTEN →" : "RECOVERY FREISCHALTEN →",
primaryHref: access.recovery ? "/pages/recovery-kompass" : "/products/find-recovery",
secondaryLabel: access.recovery ? "REFILL PRÜFEN →" : "",
secondaryHref: access.recovery ? "/products/find-recovery-refill" : "",
};
}
if (type === "regular" || type === "night") {
if (access.duty) {
return {
badge: type === "night" ? "DUTY // NACHTDIENST" : "DUTY // REGULÄRER DIENST",
module: "FiND DUTY",
copy: "Öffne deinen Duty-Kompass und bereite deinen nächsten Dienst strukturiert vor.",
items: [
"Versorgung passend zur Dienstlänge prüfen",
"Trinkpause und Priorität festlegen",
"Kompass kurz vor Dienstbeginn öffnen",
],
primaryLabel: "DUTY-KOMPASS STARTEN →",
primaryHref: "/pages/duty-kompass",
secondaryLabel: "",
secondaryHref: "",
};
}
if (onlyRecovery) {
return {
badge: type === "night" ? "FIRST SHIFT // NACHTDIENST" : "FIRST SHIFT // REGULÄRER DIENST",
module: "FiND FIRST SHIFT",
copy: "Du nutzt Recovery. First Shift ist der passende Einstieg, um die Vorbereitung vor dem Dienst kennenzulernen.",
items: [
"Pre-Shift-Check als Einstieg öffnen",
"Versorgung und Trinkmenge kurz prüfen",
"Danach Duty für wiederkehrende Dienste ergänzen",
],
primaryLabel: "FIRST SHIFT ALS EINSTIEG →",
primaryHref: "/products/find-first-shift",
secondaryLabel: "DUTY FÜR REGELDIENSTE →",
secondaryHref: "/products/find-duty",
};
}
if (access.firstShift && !access.duty) {
return {
badge: type === "night" ? "DUTY // NACHTDIENST" : "DUTY // REGULÄRER DIENST",
module: "FiND DUTY",
copy: "Für wiederkehrende reguläre Dienste und Nachtdienste ist Duty der nächste sinnvolle Hauptbaustein.",
items: [
"Regelmäßige Dienste strukturiert versorgen",
"5, 10 oder 15 Dienste passend planen",
"First Shift bleibt dein Einstieg, Duty wird deine Routine",
],
primaryLabel: "DUTY FÜR REGELDIENSTE →",
primaryHref: "/products/find-duty",
secondaryLabel: "FIRST-SHIFT-KOMPASS STARTEN →",
secondaryHref: "/pages/first-shift-kompass",
};
}
if (access.nightwatch || access.recovery) {
return {
badge: type === "night" ? "DUTY // NACHTDIENST" : "DUTY // REGULÄRER DIENST",
module: "FiND DUTY",
copy: "Dein nächster Dienst ist kein 24h-Dienst. Duty ergänzt dein System für Regeldienste, Nachtdienste und gemischte Dienstpläne.",
items: [
"Gemischten Dienstplan abdecken",
"Regel- und Nachtdienste strukturiert versorgen",
"NightWatch bleibt für lange Dienste zuständig",
],
primaryLabel: "DUTY FÜR REGELDIENSTE →",
primaryHref: "/products/find-duty",
secondaryLabel: "",
secondaryHref: "",
};
}
return {
badge: type === "night" ? "FIRST SHIFT // NACHTDIENST" : "FIRST SHIFT // REGULÄRER DIENST",
module: "FiND FIRST SHIFT",
copy: "Starte mit First Shift und öffne deinen persönlichen Einstieg in das FiND-System.",
items: [
"Dienst bewusst vorbereiten",
"Versorgung und Trinkmenge kurz prüfen",
"Mit einer klaren Routine starten",
],
primaryLabel: "FIRST SHIFT FREISCHALTEN →",
primaryHref: "/products/find-first-shift",
secondaryLabel: "",
secondaryHref: "",
};
}
return {
badge: "FiND // NÄCHSTER DIENST",
module: "DEIN FiND-SYSTEM",
copy: "Öffne den passenden Kompass und bereite deinen nächsten Dienst bewusst vor.",
items: [
"Diensttyp kurz prüfen",
"Versorgung vorbereiten",
"Priorität für den Dienst festlegen",
],
primaryLabel: "MODULE ÖFFNEN →",
primaryHref: "/pages/command-center#find-modules",
secondaryLabel: "",
secondaryHref: "",
};
}
function getRequiredModuleForShift(shift) {
const type = shift?.shift_type;
if (type === "regular" || type === "night") {
return {
key: "duty",
label: "FiND Duty",
shortLabel: "Duty",
link: "/products/find-duty",
active: access.duty,
typeLabel: type === "night" ? "Nachtdienst" : "Regeldienst",
pluralLabel: type === "night" ? "Nachtdienste" : "Regeldienste",
copy: "Für reguläre Dienste und Nachtdienste ist Duty der passende Hauptbaustein."
};
}
if (type === "long_24h" || type === "standby") {
return {
key: "nightwatch",
label: "FiND NightWatch",
shortLabel: "NightWatch",
link: "/products/find-nightwatch",
active: access.nightwatch,
typeLabel: type === "standby" ? "Bereitschaft" : "24h-Dienst",
pluralLabel: type === "standby" ? "Bereitschaften" : "24h-Dienste",
copy: "Für lange Dienste, Bereitschaften und 24h-Dienste ist NightWatch der passende Baustein."
};
}
if (type === "recovery") {
return {
key: "recovery",
label: "FiND Recovery",
shortLabel: "Recovery",
link: "/products/find-recovery",
active: access.recovery,
typeLabel: "Recovery",
pluralLabel: "Recovery-Dienste",
copy: "Für den Übergang nach dem Dienst ist Recovery der passende Baustein."
};
}
return null;
}
function getPlanGaps() {
return getUpcomingShifts()
.map((shift) => ({ shift, required: getRequiredModuleForShift(shift) }))
.filter((item) => item.required && !item.required.active);
}
function getPrimaryPlanGap() {
const gaps = getPlanGaps();
if (!gaps.length) return null;
const grouped = gaps.reduce((map, item) => {
if (!map[item.required.key]) {
map[item.required.key] = {
key: item.required.key,
required: item.required,
shifts: [],
firstTime: new Date(item.shift.start_at).getTime(),
};
}
map[item.required.key].shifts.push(item.shift);
map[item.required.key].firstTime = Math.min(map[item.required.key].firstTime, new Date(item.shift.start_at).getTime());
return map;
}, {});
return Object.values(grouped).sort((a, b) => a.firstTime - b.firstTime)[0];
}
function renderPlanAnalysis() {
if (!refs.planAnalysis) return;
const gap = getPrimaryPlanGap();
if (!gap) {
refs.planAnalysis.hidden = true;
return;
}
const count = gap.shifts.length;
const firstShift = gap.shifts.slice().sort((a, b) => new Date(a.start_at).getTime() - new Date(b.start_at).getTime())[0];
const nextShift = getUpcomingShifts()[0];
const nextRequired = nextShift ? getRequiredModuleForShift(nextShift) : null;
const nextCovered = nextRequired?.active;
const firstMissingIsNext = nextShift && firstShift && firstShift.start_at === nextShift.start_at && firstShift.end_at === nextShift.end_at && firstShift.shift_type === nextShift.shift_type;
if (count <= 1 && firstMissingIsNext && !nextCovered) {
refs.planAnalysis.hidden = true;
return;
}
refs.planAnalysis.hidden = false;
refs.planAnalysis.dataset.module = gap.key;
const serviceLabel = count === 1 ? gap.required.typeLabel : (gap.required.pluralLabel || `${gap.required.typeLabel}e`);
refs.planAnalysisTitle.textContent = `${count}x ${serviceLabel} im Plan: ${gap.required.shortLabel} passt dazu.`;
refs.planAnalysisCopy.textContent = nextCovered
? `Dein nächster Dienst ist abgedeckt. Zusätzlich ist am ${formatShortDateTime(firstShift.start_at)} ein ${gap.required.typeLabel} geplant. ${gap.required.copy}`
: `Dein Dienstplan enthält ${count === 1 ? "einen" : "mehrere"} ${serviceLabel}. ${gap.required.copy}`;
refs.planAnalysisAction.textContent = `${gap.required.shortLabel.toUpperCase()} ANSEHEN →`;
refs.planAnalysisAction.href = gap.required.link;
}
function getShiftSystemStatus(shift) {
const required = getRequiredModuleForShift(shift);
if (!required) return null;

if (shift.shift_type === "night" && access.duty && !access.recovery) {
return { text: "Recovery empfohlen", state: "neutral" };
}

if (shift.shift_type === "night" && access.duty && access.recovery) {
return { text: "Recovery aktiv", state: "active" };
}

if (required.active) {
return { text: `${required.shortLabel} aktiv`, state: "active" };
}
const primaryGap = getPrimaryPlanGap();
if (primaryGap && primaryGap.key === required.key) {
return { text: `${required.shortLabel} empfohlen`, state: "neutral" };
}
return { text: `${required.shortLabel} ergänzt`, state: "neutral" };
}
function updateCommandCenterStatusPanel(nextShift) {
const panel = document.querySelector("[data-find-cc-status-panel]");
if (!panel) return;
const title = panel.querySelector("[data-find-cc-status-title]");
const copy = panel.querySelector("[data-find-cc-status-copy]");
if (!title || !copy) return;
const now = Date.now();
const activeShift = state.shifts.find(function (shift) {
const start = new Date(shift.start_at).getTime();
const end = new Date(shift.end_at).getTime();
return start <= now && end >= now;
});
if (activeShift) {
title.textContent = "IM DIENSTMODUS.";
copy.textContent = "Dein System bleibt auf Vorbereitung, Fokus und Nachsteuerung ausgerichtet.";
panel.dataset.state = "duty-mode";
return;
}
if (nextShift) {
title.textContent = "DIENSTPLAN AKTIV.";
copy.textContent = "Deine Planung arbeitet im Hintergrund. FiND hält deine Systemschritte bereit.";
panel.dataset.state = "planned";
return;
}
if (access.firstShift || access.duty || access.nightwatch || access.recovery) {
const activeCount = [access.firstShift, access.duty, access.nightwatch, access.recovery].filter(Boolean).length;
title.textContent = activeCount === 1 ? "STARTSYSTEM BEREIT." : "SYSTEM BEREIT.";
copy.textContent = activeCount === 1
? "Trage deinen ersten Dienst ein. Danach richtet sich FiND automatisch auf deine Planung aus."
: "Dein Command Center ist vorbereitet. Der nächste Schritt entsteht aus deinem Dienstplan.";
panel.dataset.state = "ready";
return;
}
title.textContent = "ZUGANG GEÖFFNET.";
copy.textContent = "Dein Command Center ist bereit. Starte mit deinem ersten FiND-Baustein.";
panel.dataset.state = "access";
}
function updateCommandCenterNextPanel(nextShift, recommendation = null) {
const panel = document.querySelector("[data-find-cc-next-panel]");
if (!panel) return;
const kicker = panel.querySelector("[data-find-cc-next-kicker]");
const name = panel.querySelector("[data-find-cc-next-name]");
const text = panel.querySelector("[data-find-cc-next-text]");
const action = panel.querySelector("[data-find-cc-next-action]");
if (!kicker || !name || !text || !action) return;
if (!nextShift) {
kicker.textContent = "DIENSTPLAN";
name.textContent = "Starte mit deinem ersten Dienst.";
text.textContent = "Wähle im Kalender einen Tag aus. Danach erkennt FiND automatisch den passenden Kompass.";
action.textContent = "DIENST IM KALENDER EINTRAGEN →";
action.href = "#find-next-shift";
action.classList.remove("is-system-action", "is-product-action");
delete action.dataset.fscAction;
panel.dataset.state = "empty";
return;
}
const rec = recommendation || getRecommendation(nextShift);
const shiftTitle = nextShift.title || getTypeLabel(nextShift.shift_type);
kicker.textContent = "NÄCHSTER DIENST";
name.textContent = shiftTitle;
text.textContent = `${rec.module}: ${rec.copy}`;
const isProductAction = String(rec.primaryHref || "").includes("/products/");
action.textContent = rec.primaryLabel;
action.href = rec.primaryHref;
action.classList.toggle("is-system-action", !isProductAction);
action.classList.toggle("is-product-action", isProductAction);
delete action.dataset.fscAction;
panel.dataset.state = "ready";
}
function renderRecommendation() {
const nextShift = getUpcomingShifts()[0];

if (!nextShift) {
updateCommandCenterStatusPanel(null);
updateCommandCenterNextPanel(null);

if (refs.recommendationAction) refs.recommendationAction.hidden = true;

let emptySteps = refs.recommendation.querySelector("[data-fsc-empty-steps]");

if (!emptySteps) {
emptySteps = document.createElement("ul");
emptySteps.className = "fsc__recommendation-empty-steps";
emptySteps.setAttribute("data-fsc-empty-steps", "");
refs.recommendationMeta.insertAdjacentElement("afterend", emptySteps);
}

emptySteps.replaceChildren();

["1. Tag wählen", "2. Diensttyp und Uhrzeit eintragen", "3. FiND zeigt deinen nächsten Schritt"].forEach(function (step) {
const listItem = document.createElement("li");
listItem.textContent = step;
emptySteps.append(listItem);
});

emptySteps.hidden = false;

refs.recommendation.dataset.state = "empty";
refs.recommendationBadge.textContent = "SYSTEMSTART";
refs.recommendationTitle.textContent = "So startet dein System";
refs.recommendationMeta.textContent = "Trage deinen ersten Dienst ein. Danach richtet sich dein Command Center automatisch aus.";
refs.recommendationCountdown.textContent = "";
refs.recommendationChecklist.replaceChildren();
refs.recommendationSecondary.hidden = true;
refs.recommendationSecondary.removeAttribute("href");
refs.recommendation.hidden = false;

return;
}

const recommendation = getRecommendation(nextShift);
const isProductAction = String(recommendation.primaryHref || "").includes("/products/");

if (refs.recommendationAction) refs.recommendationAction.hidden = false;

/* Wichtig:
   Die leeren Start-Schritte werden beim ersten geplanten Dienst entfernt,
   nicht nur versteckt. Dadurch bleiben sie nach dem Speichern nicht bis zum Reload sichtbar. */
const emptySteps = refs.recommendation.querySelector("[data-fsc-empty-steps]");
if (emptySteps) emptySteps.remove();

refs.recommendation.dataset.state = isProductAction ? "planned-product" : "planned-active";

const shiftTitle = nextShift.title || getTypeLabel(nextShift.shift_type);

updateCommandCenterStatusPanel(nextShift);
updateCommandCenterNextPanel(nextShift, recommendation);

refs.recommendationBadge.textContent = recommendation.badge;
refs.recommendationTitle.textContent = shiftTitle;
refs.recommendationMeta.textContent =
`${formatDateTime(nextShift.start_at)} → ${formatDateTime(nextShift.end_at)} · ${formatDuration(nextShift)}`;
refs.recommendationCountdown.textContent = formatCountdown(nextShift);
refs.recommendationModule.textContent = recommendation.module;
refs.recommendationCopy.textContent = recommendation.copy;
refs.recommendationPrimary.textContent = recommendation.primaryLabel;
refs.recommendationPrimary.href = recommendation.primaryHref;
refs.recommendationPrimary.classList.toggle("is-system-action", !isProductAction);
refs.recommendationPrimary.classList.toggle("is-product-action", isProductAction);

refs.recommendationChecklist.replaceChildren();

for (const item of recommendation.items) {
const listItem = document.createElement("li");
listItem.textContent = item;
refs.recommendationChecklist.append(listItem);
}

if (recommendation.secondaryHref) {
refs.recommendationSecondary.hidden = false;
refs.recommendationSecondary.textContent = recommendation.secondaryLabel;
refs.recommendationSecondary.href = recommendation.secondaryHref;
} else {
refs.recommendationSecondary.hidden = true;
refs.recommendationSecondary.removeAttribute("href");
}

refs.recommendation.hidden = false;
}
function renderStats() {
const upcoming = getUpcomingShifts();
const nextShift = upcoming[0];
refs.statNext.textContent = nextShift
? `${getTypeLabel(nextShift.shift_type)} · ${formatShortDateTime(nextShift.start_at)}`
: "Dienstplan leer";
const counts = {
regular: upcoming.filter((shift) => shift.shift_type === "regular").length,
night: upcoming.filter((shift) => shift.shift_type === "night").length,
long24: upcoming.filter((shift) => shift.shift_type === "long_24h").length,
standby: upcoming.filter((shift) => shift.shift_type === "standby").length,
recovery: upcoming.filter((shift) => shift.shift_type === "recovery").length,
};
refs.statRegularNight.textContent = String(counts.regular + counts.night);
refs.statLong24.textContent = String(counts.long24 + counts.standby);
refs.statPlanned.textContent = String(upcoming.length);
}
function renderCalendar() {
initializeMonthCursor();
refs.calendarGrid.replaceChildren();
const firstDay = new Date(
Date.UTC(state.monthCursor.year, state.monthCursor.month - 1, 1),
);
const dayCount = new Date(
Date.UTC(state.monthCursor.year, state.monthCursor.month, 0),
).getUTCDate();
const mondayBasedOffset = (firstDay.getUTCDay() + 6) % 7;
refs.monthLabel.textContent = monthFormatter.format(firstDay);
const shiftsByDate = new Map();
for (const shift of state.shifts) {
for (const key of getShiftDateKeys(shift)) {
const existing = shiftsByDate.get(key) || [];
existing.push(shift);
shiftsByDate.set(key, existing);
}
}
for (let index = 0; index < mondayBasedOffset; index += 1) {
const blank = document.createElement("div");
blank.className = "fsc__calendar-blank";
refs.calendarGrid.append(blank);
}
const todayKey = getDateKey(new Date());
for (let day = 1; day <= dayCount; day += 1) {
const key = [
state.monthCursor.year,
String(state.monthCursor.month).padStart(2, "0"),
String(day).padStart(2, "0"),
].join("-");
const shifts = shiftsByDate.get(key) || [];
const button = document.createElement("button");
button.type = "button";
button.className = "fsc__calendar-day";
button.dataset.today = String(key === todayKey);
button.setAttribute(
"aria-label",
`${day}. ${refs.monthLabel.textContent}: Dienst eintragen`,
);
const number = document.createElement("span");
number.className = "fsc__calendar-day-number";
number.textContent = String(day);
const markers = document.createElement("span");
markers.className = "fsc__calendar-markers";
for (const shift of shifts.slice(0, 3)) {
const marker = document.createElement("span");
marker.className = "fsc__calendar-marker";
marker.dataset.type = shift.shift_type;
marker.title = getTypeLabel(shift.shift_type);
markers.append(marker);
}
if (shifts.length > 3) {
const more = document.createElement("span");
more.className = "fsc__calendar-more";
more.textContent = `+${shifts.length - 3}`;
markers.append(more);
}
button.append(number, markers);
button.addEventListener("click", () => openCreateDialog(key));
refs.calendarGrid.append(button);
}
}
function getSortedShifts() {
const now = Date.now();
return [...state.shifts].sort((a, b) => {
const aPast = new Date(a.end_at).getTime() < now;
const bPast = new Date(b.end_at).getTime() < now;
if (aPast !== bPast) return aPast ? 1 : -1;
return aPast
? new Date(b.start_at).getTime() - new Date(a.start_at).getTime()
: new Date(a.start_at).getTime() - new Date(b.start_at).getTime();
});
}
function updateShiftListViewport() {
if (!refs.shiftList) return;
const cards = Array.from(refs.shiftList.querySelectorAll(".fsc__shift"));
refs.shiftList.style.removeProperty("max-height");
if (cards.length <= 3) return;
const listStyle = window.getComputedStyle(refs.shiftList);
const gap = Number.parseFloat(listStyle.rowGap || listStyle.gap || "0") || 0;
const visibleHeight = cards
.slice(0, 3)
.reduce((height, card) => height + card.getBoundingClientRect().height, 0);
refs.shiftList.style.maxHeight = `${Math.ceil(visibleHeight + gap * 2)}px`;
}
function renderShiftList() {
refs.shiftList.replaceChildren();
const shifts = getSortedShifts();
if (refs.shiftListHint) {
refs.shiftListHint.hidden = shifts.length <= 3;
}
if (shifts.length === 0) {
const empty = document.createElement("div");
empty.className = "fsc__empty";
empty.textContent =
"Noch keine Dienste eingetragen. Klicke links im Kalender auf einen Tag, um deinen ersten Dienst anzulegen.";
refs.shiftList.append(empty);
updateShiftListViewport();
return;
}
for (const shift of shifts) {
const card = document.createElement("article");
card.className = "fsc__shift";
card.dataset.type = shift.shift_type;
card.dataset.past = String(new Date(shift.end_at).getTime() < Date.now());
const line = document.createElement("div");
line.className = "fsc__shift-line";
const content = document.createElement("div");
const title = document.createElement("h4");
title.className = "fsc__shift-title";
title.textContent = shift.title || getTypeLabel(shift.shift_type);
const meta = document.createElement("p");
meta.className = "fsc__shift-meta";
meta.textContent =
`${formatDateTime(shift.start_at)} → ${formatDateTime(shift.end_at)} · ${formatDuration(shift)}`;
const tag = document.createElement("span");
tag.className = "fsc__shift-tag";
tag.textContent = getTypeLabel(shift.shift_type);
const systemStatus = getShiftSystemStatus(shift);
if (systemStatus) {
const status = document.createElement("span");
status.className = `fsc__shift-system-status is-${systemStatus.state}`;
status.textContent = systemStatus.text;
content.append(title, meta, tag, status);
} else {
content.append(title, meta, tag);
}
if (shift.note) {
const note = document.createElement("p");
note.className = "fsc__shift-note";
note.textContent = shift.note;
content.append(note);
}
const edit = document.createElement("button");
edit.type = "button";
edit.className = "fsc__button fsc__button--secondary fsc__edit";
edit.textContent = "Bearbeiten";
edit.addEventListener("click", () => openEditDialog(shift));
card.append(line, content, edit);
refs.shiftList.append(card);
}
window.requestAnimationFrame(updateShiftListViewport);
}
function maskPhoneNumber(phoneNumber = "") {
const compact = String(phoneNumber).replace(/\s+/g, "");
if (compact.length < 7) return compact || "–";
return `${compact.slice(0, 3)} •••• ••• ${compact.slice(-4)}`;
}
function setWhatsappError(message = "") {
if (!refs.whatsappError) return;
refs.whatsappError.textContent = message;
refs.whatsappError.hidden = !message;
}


function getStoredCalendarConnectionType() {
try {
return window.localStorage.getItem("findCalendarConnectionType") || "";
} catch {
return "";
}
}
function setStoredCalendarConnectionType(value) {
try {
if (value) {
window.localStorage.setItem("findCalendarConnectionType", value);
} else {
window.localStorage.removeItem("findCalendarConnectionType");
}
} catch {}
}
function hasCalendarFeedUrl() {
return typeof state.calendarFeed?.ics_url === "string" && state.calendarFeed.ics_url.length > 0;
}
function getCalendarConnectionType() {
const type = getStoredCalendarConnectionType();
if (type === "apple" || type === "google") return type;
if (type === "ical") {
setStoredCalendarConnectionType("");
return "";
}
return "";
}
function getCalendarConnectionLabel() {
const type = getCalendarConnectionType();
const hasFeed = hasCalendarFeedUrl();

if (type === "apple" && hasFeed) return "Apple Kalender aktiv";
if (type === "google" && hasFeed) return "Google Kalender aktiv";
if (hasFeed) return "Kalender bereit";

return "Kalender nicht verbunden";
}

function getWhatsappConnectionLabel() {
const status = String(state.whatsappProfile?.status || "").toLowerCase();

if (status === "active") return "WhatsApp verbunden";

if (["revoked", "disabled", "paused", "inactive", "opted_out", "opted-out"].includes(status)) {
return "WhatsApp pausiert";
}

return "WhatsApp nicht verbunden";
}

function getConnectStatusText() {
return `${getCalendarConnectionLabel()} · ${getWhatsappConnectionLabel()}`;
}

function setConnectPillState(pill, active, title) {
if (!pill) return;

pill.classList.toggle("is-active", Boolean(active));
pill.classList.toggle("is-inactive", !active);
pill.setAttribute("title", title || "");
pill.setAttribute("aria-label", title || "");
}

function updateConnectStatusPills() {
const calendarType = getCalendarConnectionType();
const calendarActive = hasCalendarFeedUrl() && (calendarType === "apple" || calendarType === "google");
const whatsappStatus = String(state.whatsappProfile?.status || "").toLowerCase();
const whatsappActive = whatsappStatus === "active";

setConnectPillState(
refs.connectCalendarStatusPill,
calendarActive,
getCalendarConnectionLabel(),
);

setConnectPillState(
refs.connectWhatsappStatusPill,
whatsappActive,
getWhatsappConnectionLabel(),
);
}

function updateConnectPanel() {
if (!refs.connectPanel) return;

const whatsappVisible = refs.whatsapp && refs.whatsapp.hidden === false;
const feedVisible = refs.calendarFeed && refs.calendarFeed.hidden === false;
const visible = whatsappVisible || feedVisible;

refs.connectPanel.hidden = !visible;

const expanded = refs.connectPanel.dataset.expanded === "true";

refs.connectPanel.classList.toggle("is-open", expanded);
refs.connectPanel.classList.toggle("is-collapsed", !expanded);
refs.connectPanel.dataset.calendarState = getCalendarConnectionType() || (hasCalendarFeedUrl() ? "ready" : "none");
refs.connectPanel.dataset.whatsappState = String(state.whatsappProfile?.status || "none").toLowerCase();

if (refs.connectContent) refs.connectContent.hidden = !expanded;
if (refs.connectToggle) refs.connectToggle.setAttribute("aria-expanded", expanded ? "true" : "false");

if (refs.connectStatus) refs.connectStatus.textContent = getConnectStatusText();

updateConnectStatusPills();
}

function getPreparedWhatsappPhone() {
return (
state.whatsappProfile?.phone_e164 ||
state.customer?.whatsapp_phone ||
state.customer?.phone ||
""
);
}

function renderWhatsappOptin() {
if (!refs.whatsapp) return;
if (!access.whatsappOptin) {
refs.whatsapp.hidden = true;
updateConnectPanel();
return;
}
refs.whatsapp.hidden = false;
const profile = state.whatsappProfile;
const active = profile?.status === "active";
const expanded = refs.whatsapp.dataset.expanded === "true";
const hasShifts = getUpcomingShifts().length > 0;
refs.whatsapp.dataset.state = active ? "active" : "inactive";
refs.whatsappForm.hidden = active || !expanded;
refs.whatsappStatus.hidden = !active;
if (refs.whatsappToggle) {
refs.whatsappToggle.hidden = active;
refs.whatsappToggle.textContent = expanded ? "SCHLIESSEN" : (hasShifts ? "AKTIVIEREN →" : "VORBEREITEN →");
refs.whatsappToggle.classList.add("is-secondary-priority");
}
if (refs.whatsappDisable) {
refs.whatsappDisable.hidden = !active;
}
if (refs.whatsappSummary) {
const preparedPhone = getPreparedWhatsappPhone();
refs.whatsappSummary.textContent = active
? "Deine Erinnerungen sind aktiv und werden passend zu deinen geplanten Diensten gesendet."
: preparedPhone
? "Deine Mobilnummer ist aus deinem Kundenkonto vorbereitet. Aktiviere WhatsApp, wenn du Erinnerungen erhalten möchtest."
: hasShifts
? "Erhalte kurze Hinweise passend zu deinen geplanten Diensten."
: "Bereite WhatsApp vor. Sobald du Dienste einträgst, können passende Hinweise gesendet werden.";
}
const preparedPhone = getPreparedWhatsappPhone();
if (preparedPhone && refs.whatsappPhone && !refs.whatsappPhone.value) {
refs.whatsappPhone.value = preparedPhone;
}
if (active) {
refs.whatsappState.textContent = "AKTIV";
refs.whatsappPhoneDisplay.textContent = maskPhoneNumber(profile.phone_e164);
}
updateConnectPanel();
}

function getAppleCalendarUrl(icsUrl) {
if (!icsUrl) return "#";
return icsUrl.replace(/^https?:\/\//i, "webcal://");
}
function getGoogleCalendarUrl(icsUrl) {
if (!icsUrl) return "#";
return `https://calendar.google.com/calendar/render?cid=${encodeURIComponent(icsUrl)}`;
}
function renderCalendarFeed() {
if (!refs.calendarFeed) return;
refs.calendarFeed.hidden = false;
const feed = state.calendarFeed || {};
const icsUrl = typeof feed.ics_url === "string" ? feed.ics_url : "";
const hasUrl = icsUrl.length > 0;
if (refs.feedApple) {
refs.feedApple.href = hasUrl ? getAppleCalendarUrl(icsUrl) : "#";
refs.feedApple.setAttribute("aria-disabled", hasUrl ? "false" : "true");
refs.feedApple.title = hasUrl ? "Öffnet Apple Kalender als Abonnement" : "Kalenderlink noch nicht verfügbar";
}
if (refs.feedGoogle) {
refs.feedGoogle.href = hasUrl ? getGoogleCalendarUrl(icsUrl) : "#";
refs.feedGoogle.setAttribute("aria-disabled", hasUrl ? "false" : "true");
}
if (refs.feedCopy) refs.feedCopy.disabled = !hasUrl || state.calendarFeedBusy;
if (refs.feedRegenerate) refs.feedRegenerate.disabled = state.calendarFeedBusy;
updateConnectPanel();
}
async function copyTextToClipboard(value) {
if (navigator.clipboard && window.isSecureContext) {
await navigator.clipboard.writeText(value);
return;
}
const textarea = document.createElement("textarea");
textarea.value = value;
textarea.setAttribute("readonly", "");
textarea.style.position = "fixed";
textarea.style.left = "-9999px";
document.body.appendChild(textarea);
textarea.select();
document.execCommand("copy");
textarea.remove();
}
function render() {
renderRecommendation();
renderWhatsappOptin();
renderCalendarFeed();
renderStats();
renderPlanAnalysis();
renderCalendar();
renderShiftList();
}
function populateShiftTypes(selectedValue = "regular") {
refs.shiftType.replaceChildren();
for (const option of state.shiftTypeOptions) {
const element = document.createElement("option");
element.value = option.value;
element.textContent = option.label;
element.selected = option.value === selectedValue;
refs.shiftType.append(element);
}
}
function openModal() {
refs.modal.hidden = false;
refs.modal.setAttribute("aria-hidden", "false");
document.documentElement.style.overflow = "hidden";
}
function closeModal() {
refs.modal.hidden = true;
refs.modal.setAttribute("aria-hidden", "true");
document.documentElement.style.overflow = "";
setFormError();
}
function openCreateDialog(dateKey = "") {
const today = dateKey || getDateKey(new Date());
refs.dialogTitle.textContent = "Dienst eintragen";
refs.shiftId.value = "";
refs.title.value = "";
refs.note.value = "";
refs.start.value = `${today}T08:00`;
refs.end.value = `${today}T20:00`;
refs.delete.hidden = true;
populateShiftTypes("regular");
setFormError();
openModal();
}
function openEditDialog(shift) {
refs.dialogTitle.textContent = "Dienst bearbeiten";
refs.shiftId.value = shift.id;
refs.title.value = shift.title || "";
refs.note.value = shift.note || "";
refs.start.value = getDateTimeLocalValue(shift.start_at);
refs.end.value = getDateTimeLocalValue(shift.end_at);
refs.delete.hidden = false;
populateShiftTypes(shift.shift_type);
setFormError();
openModal();
}
function renderLoggedOut() {
refs.content.hidden = true;
refs.login.hidden = false;
const loginUrl = root.dataset.loginUrl || "/account/login";
const returnUrl = encodeURIComponent(
window.location.pathname + window.location.search,
);
refs.loginLink.href =
`${loginUrl}${loginUrl.includes("?") ? "&" : "?"}return_url=${returnUrl}`;
setSync("error", "Kundenlogin erforderlich");
}
async function load({ silent = false } = {}) {
if (!silent) hideNotice();
setSync("loading", "Kalender wird synchronisiert");
try {
const payload = await api("bootstrap");
state.customer = payload.customer || null;
state.shifts = payload.shifts || [];
state.shiftTypeOptions = payload.shift_type_options || [];
state.whatsappProfile = payload.whatsapp_profile || null;
state.calendarFeed = payload.calendar_feed || null;
state.csrfToken = payload.csrf_token || "";
state.timeZone = payload.customer?.timezone || "Europe/Berlin";
refs.login.hidden = true;
refs.content.hidden = false;
render();
setSync("ready", "Geräteübergreifend synchronisiert");
} catch (error) {
if (error.message === "Customer login required") {
renderLoggedOut();
return;
}
refs.content.hidden = true;
refs.login.hidden = true;
setSync("error", "Verbindung fehlgeschlagen");
showNotice(error.message, "error");
}
}
refs.form.addEventListener("submit", async (event) => {
event.preventDefault();
if (state.busy) return;
state.busy = true;
refs.save.disabled = true;
refs.delete.disabled = true;
setFormError();
try {
const body = {
csrf_token: state.csrfToken,
shift_type: refs.shiftType.value,
title: refs.title.value,
start_at: zonedLocalValueToIso(refs.start.value),
end_at: zonedLocalValueToIso(refs.end.value),
note: refs.note.value,
};
const action = refs.shiftId.value ? "update-shift" : "create-shift";
if (refs.shiftId.value) {
body.shift_id = refs.shiftId.value;
}
const payload = await api(action, {
method: "POST",
body,
});
if (Array.isArray(payload.shifts)) {
state.shifts = payload.shifts;
render();
} else if (payload.shift && payload.shift.id) {
const index = state.shifts.findIndex((shift) => String(shift.id) === String(payload.shift.id));
if (index >= 0) {
state.shifts.splice(index, 1, payload.shift);
} else {
state.shifts.push(payload.shift);
}
render();
}
closeModal();
await load({ silent: true });
window.requestAnimationFrame(render);
showNotice(
action === "create-shift"
? "Dienst wurde gespeichert."
: "Dienst wurde aktualisiert.",
"success",
);
} catch (error) {
setFormError(error.message);
} finally {
state.busy = false;
refs.save.disabled = false;
refs.delete.disabled = false;
}
});
refs.delete.addEventListener("click", async () => {
const shiftId = refs.shiftId.value;
if (!shiftId || state.busy) return;
const confirmed = window.confirm(
"Soll dieser Dienst wirklich gelöscht werden?",
);
if (!confirmed) return;
state.busy = true;
refs.save.disabled = true;
refs.delete.disabled = true;
setFormError();
try {
const payload = await api("delete-shift", {
method: "POST",
body: {
csrf_token: state.csrfToken,
shift_id: shiftId,
},
});
if (Array.isArray(payload.shifts)) {
state.shifts = payload.shifts;
render();
} else {
state.shifts = state.shifts.filter((shift) => String(shift.id) !== String(shiftId));
render();
}
closeModal();
await load({ silent: true });
window.requestAnimationFrame(render);
showNotice("Dienst wurde gelöscht.", "success");
} catch (error) {
setFormError(error.message);
} finally {
state.busy = false;
refs.save.disabled = false;
refs.delete.disabled = false;
}
});
if (refs.connectToggle) {
refs.connectToggle.addEventListener("click", () => {
if (!refs.connectPanel) return;
refs.connectPanel.dataset.expanded = refs.connectPanel.dataset.expanded === "true" ? "false" : "true";
updateConnectPanel();
});
}

if (refs.whatsappToggle) {
refs.whatsappToggle.addEventListener("click", () => {
refs.whatsapp.dataset.expanded = refs.whatsapp.dataset.expanded === "true" ? "false" : "true";
renderWhatsappOptin();
});
}
if (refs.whatsappForm) {
refs.whatsappForm.addEventListener("submit", async (event) => {
event.preventDefault();
if (state.whatsappBusy) return;
state.whatsappBusy = true;
refs.whatsappEnable.disabled = true;
setWhatsappError();
try {
const payload = await api("enable-whatsapp-reminders", {
method: "POST",
body: {
csrf_token: state.csrfToken,
phone_e164: refs.whatsappPhone.value,
accepted: refs.whatsappAccepted.checked,
},
});
state.whatsappProfile = payload.whatsapp_profile || null;
refs.whatsappAccepted.checked = false;
refs.whatsapp.dataset.expanded = "false";
renderWhatsappOptin();
showNotice("WhatsApp-Erinnerungen wurden aktiviert.", "success");
} catch (error) {
setWhatsappError(error.message);
} finally {
state.whatsappBusy = false;
refs.whatsappEnable.disabled = false;
}
});
}
if (refs.whatsappDisable) {
refs.whatsappDisable.addEventListener("click", async () => {
if (state.whatsappBusy) return;
const confirmed = window.confirm(
"Möchtest du deine WhatsApp-Erinnerungen wirklich deaktivieren?",
);
if (!confirmed) return;
state.whatsappBusy = true;
refs.whatsappDisable.disabled = true;
setWhatsappError();
try {
const payload = await api("disable-whatsapp-reminders", {
method: "POST",
body: {
csrf_token: state.csrfToken,
},
});
state.whatsappProfile = payload.whatsapp_profile || null;
renderWhatsappOptin();
showNotice("WhatsApp-Erinnerungen wurden deaktiviert.", "success");
} catch (error) {
showNotice(error.message, "error");
} finally {
state.whatsappBusy = false;
refs.whatsappDisable.disabled = false;
}
});
}

if (refs.feedApple) {
refs.feedApple.addEventListener("click", () => {
if (state.calendarFeed?.ics_url) {
setStoredCalendarConnectionType("apple");
updateConnectPanel();
}
});
}
if (refs.feedGoogle) {
refs.feedGoogle.addEventListener("click", () => {
if (state.calendarFeed?.ics_url) {
setStoredCalendarConnectionType("google");
updateConnectPanel();
}
});
}

if (refs.feedCopy) {
refs.feedCopy.addEventListener("click", async () => {
const url = state.calendarFeed?.ics_url || "";
if (!url) {
showNotice("Kalenderlink ist noch nicht verfügbar.", "error");
return;
}
try {
await copyTextToClipboard(url);
updateConnectPanel();
showNotice("iCal-Link wurde kopiert.", "success");
} catch {
showNotice("Link konnte nicht automatisch kopiert werden.", "error");
}
});
}
if (refs.feedRegenerate) {
refs.feedRegenerate.addEventListener("click", async () => {
if (state.calendarFeedBusy) return;
const confirmed = window.confirm(
"Neuen Kalenderlink erstellen? Der alte iCal-Link funktioniert danach nicht mehr.",
);
if (!confirmed) return;
state.calendarFeedBusy = true;
renderCalendarFeed();
try {
const payload = await api("regenerate-calendar-feed", {
method: "POST",
body: {
csrf_token: state.csrfToken,
},
});
state.calendarFeed = payload.calendar_feed || null;
setStoredCalendarConnectionType("");
renderCalendarFeed();
showNotice("Kalenderlink wurde neu erstellt.", "success");
} catch (error) {
showNotice(error.message, "error");
} finally {
state.calendarFeedBusy = false;
renderCalendarFeed();
}
});
}

const commandCenterTopAction = document.querySelector("[data-find-cc-next-action]");
if (commandCenterTopAction) {
commandCenterTopAction.addEventListener("click", (event) => {
if (commandCenterTopAction.dataset.fscAction === "add-shift") {
event.preventDefault();
openCreateDialog();
}
});
}
if (refs.refresh) {
refs.refresh.addEventListener("click", () => load());
}
refs.previousMonth.addEventListener("click", () => shiftMonth(-1));
refs.nextMonth.addEventListener("click", () => shiftMonth(1));
refs.closeModal.forEach((button) => {
button.addEventListener("click", closeModal);
});
document.addEventListener("keydown", (event) => {
if (event.key === "Escape" && !refs.modal.hidden) {
closeModal();
}
});
state.recommendationTimer = window.setInterval(() => {
renderRecommendation();
}, 60000);
let shiftListResizeTimer = 0;
window.addEventListener("resize", () => {
window.clearTimeout(shiftListResizeTimer);
shiftListResizeTimer = window.setTimeout(updateShiftListViewport, 120);
});
load();
})();
